module.exports = __webpack_public_path__ + "img/cjlb.c7a720cc.png";